import React from 'react';
import PropTypes from 'prop-types';
import { InfoOutlined } from '@mui/icons-material';
import { Link } from 'react-router-dom'

const NotificationBanner = (props) => {
    const { title, message, close, type, action, path } = props; 
    if (message) {
        setTimeout(close, 5000)
    }
    return (
        <div className={`alert__banner ${type}`}>
              <div className="notification-column">  
                <InfoOutlined />
                <div>
                    <h3>{title}</h3>
                    <p>{message}</p> 
                    {action && (<Link to={path} className="notification-action-link">{action}</Link>)}
                </div>
                </div>
                {close && <div className="closeIcon" onClick={close}>X</div> }                 
        </div>
    )
};

NotificationBanner.propTypes = {
    title: PropTypes.string,
    message: PropTypes.string,
    type: PropTypes.string,
    close: PropTypes.func
};

export default NotificationBanner;